// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"ed965d41","55":"ed965d41","283":"ed965d41","492":"ed965d41","606":"ed965d41","789":"ed965d41","804":"ed965d41"}[chunkId] + ".chunk.css";
};